export enum FileType {
  DisposalRequest = "dr",
  BidTemplate = "bid-template",
  BidFile = "bid-file",
  LotFile = "lot-file",
  Media = "media",
  AuctionImage = "auction-image",
}
